import { FC } from "react";

interface IconProps {
  color?: string;
}

const Flag: FC<IconProps> = ({ color = "#DC787B" }) => (
  <svg viewBox="0 0 16 16" stroke={color} xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.666 14.667V10M2.666 9.999s.667-.667 2.667-.667c2 0 3.333 1.333 5.333 1.333S13.333 10 13.333 10v-8s-.667.666-2.667.666c-2 0-3.333-1.333-5.333-1.333s-2.667.667-2.667.667v8Z"
      fill="none"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Flag;
